import { Component, computed, input, InputSignal, Signal } from '@angular/core';
import { ChronoPipe } from '../../../pipes/chrono-pipe';
import { DataItemTemplate } from '../../../templates/data-item-template/data-item-template';
import { Icon, IconType } from '../../icon/icon';
import { UIBlockType } from '../../../models/ui-block-type.model';
import { WSBroadcastDataMessage } from '../../../models/WSMessages/WS-broadcast-data-message.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'li[app-default-data-item-block]',
  imports: [DataItemTemplate, Icon, TranslateModule],
  providers: [ChronoPipe],
  template: `
    <app-data-item-template [dataBlock]="dataBlock()">
      <app-icon
        [color]="isFlip() ? 'black' : 'white'"
        [size]="iconSize()"
        class="icon"
        [icon]="icon()"
      />
      @if (!isFlip()) {
        <p class="name">{{ unit() }}</p>
        <p class="value">{{ value() }}</p>
      } @else {
        <p class="average-value">{{ averageValue() }}</p>
        <p class="name">{{ unit() }} {{ 'common.metric.average.short' | translate }}</p>
      }
    </app-data-item-template>
  `,
  styleUrl: './default-data-item-block.scss',
})
export class DefaultDataBlockItem extends DataItemTemplate {
  icon: InputSignal<IconType> = input.required();
  value: Signal<number | [number, number]> = computed(() => {
    const key: keyof WSBroadcastDataMessage['data'] | undefined = this.broadcastDataKey();
    return key ? this.broadcastData()[key] : 0;
  });
  averageValue: Signal<number | [number, number] | undefined> = computed(() => {
    const key: keyof WSBroadcastDataMessage['data'] | undefined = this.broadcastAverageDataKey();
    const data: number | [number, number] | undefined = key ? this.broadcastData()[key] : undefined;
    return typeof data === 'number' ? Math.round(data) : data;
  });

  unit: InputSignal<string | undefined> = input();
  type: Signal<UIBlockType | undefined> = computed(() => this.dataBlock().type);

  private readonly broadcastDataKey: Signal<keyof WSBroadcastDataMessage['data'] | undefined> =
    computed(() => {
      switch (this.type()) {
        default:
          return this.type() as keyof WSBroadcastDataMessage['data'];
      }
    });

  private readonly broadcastAverageDataKey: Signal<
    keyof WSBroadcastDataMessage['data'] | undefined
  > = computed(() => {
    if (!this.type()) return undefined;
    const capitalized: string = this.type()!.charAt(0).toUpperCase() + this.type()!.slice(1);
    switch (this.type()) {
      default:
        return ('avg' + capitalized) as keyof WSBroadcastDataMessage['data'];
    }
  });
}
